import React, { useState, useEffect } from "react";
import FormularioDinamico from "../../../common/components/formularios/FormularioDinamico";
import { useApi } from "../../../hooks/useApi"; 

export default function GestionFormularios({ usuario, onBackToMenu }) {
  const [formularioActivo, setFormularioActivo] = useState(null);
  const [formularios, setFormularios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const { request } = useApi();

  useEffect(() => {
    const cargarFormularios = async () => {
      setLoading(true);
      const res = await request('/formularios-dinamicos');
      
      const datosFormularios = Array.isArray(res?.data?.data) ? res.data.data 
                             : Array.isArray(res?.data) ? res.data 
                             : Array.isArray(res) ? res : null;

      if (Array.isArray(datosFormularios)) {
        setFormularios(datosFormularios);
        setError(null);
      } else {
        setFormularios([]);
        setError("No se pudieron cargar los formularios disponibles.");
      }
      setLoading(false);
    };

    cargarFormularios();
  }, []);

  return (
    <div className="w-full animate-fade-in-up">
      {/* HEADER DEL MÓDULO */}
      <div className="flex flex-col sm:flex-row justify-between items-center mb-8 gap-4 bg-white dark:bg-slate-800 p-6 rounded-3xl border border-slate-200 dark:border-slate-700 shadow-sm transition-colors">
        <div>
          <h1 className="text-2xl font-black text-slate-900 dark:text-white flex items-center gap-3">
            <span className="text-3xl">📋</span> Gestión de Formularios
          </h1>
          <p className="text-sm text-slate-600 dark:text-slate-400 font-medium mt-1">
            Administración y configuración de formatos dinámicos
          </p>
        </div>
        <button 
          onClick={onBackToMenu}
          className="btn-interactive px-5 py-2.5 bg-slate-900 dark:bg-slate-700 text-white rounded-full text-xs font-bold shadow-md hover:bg-slate-800 dark:hover:bg-slate-600 tracking-wide uppercase cursor-pointer"
        >
          Volver al Menú
        </button>
      </div>

      {/* ÁREA DE TRABAJO */}
      {!formularioActivo ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          
          {loading ? (
            <div className="col-span-full py-16 flex flex-col items-center justify-center">
              <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-3"></div>
              <p className="text-slate-700 dark:text-slate-300 font-bold text-sm uppercase tracking-widest">Cargando formatos...</p>
            </div>
          ) : error && formularios.length === 0 ? (
            <div className="col-span-full p-6 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-400 text-center rounded-2xl">
              <p className="font-bold">⚠️ {error}</p>
            </div>
          ) : formularios.length === 0 ? (
            <div className="col-span-full p-10 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-center text-slate-500 dark:text-slate-400 font-bold rounded-2xl">
              No hay formularios configurados en la base de datos actualmente.
            </div>
          ) : (
            formularios.map((form, index) => (
              <div key={form.slug || index} className="bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-200 dark:border-slate-700 p-6 flex flex-col justify-between h-full group hover:border-blue-400 dark:hover:border-blue-500 transition-all cursor-pointer">
                <div>
                  <div className="w-12 h-12 rounded-xl bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 flex items-center justify-center text-2xl mb-4 icon-bounce">
                    {form.icono || "📄"}
                  </div>
                  <h3 className="font-extrabold text-slate-900 dark:text-white text-lg mb-2">{form.titulo}</h3>
                  <p className="text-xs text-slate-500 dark:text-slate-400 font-medium mb-4 line-clamp-2">
                    {form.descripcion}
                  </p>
                </div>
                <button 
                  onClick={() => setFormularioActivo(form.slug)}
                  className="w-full py-3 mt-4 bg-slate-100 dark:bg-slate-700 text-slate-700 dark:text-slate-200 rounded-xl text-xs font-black uppercase tracking-wider group-hover:bg-blue-600 group-hover:text-white transition-all btn-interactive cursor-pointer"
                >
                  Editar Formato
                </button>
              </div>
            ))
          )}
        </div>
      ) : (
        <div>
          <FormularioDinamico 
            slug={formularioActivo} 
            usuario={usuario} 
            modo="edicion"
            onGuardadoExitoso={(res) => {
              alert("¡Formato actualizado con éxito!");
              setFormularioActivo(null);
            }}
            onCancelar={() => setFormularioActivo(null)} 
          />
        </div>
      )}
    </div>
  );
}